import React from "react";

import { useQuery } from "@tanstack/react-query";
import { MonitorPlay } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import ProjectAPI from "@/src/api/ProjectAPI";
import { isValidHttpUrl } from "@/src/utils/url";

import AppearancePreviewFrame from "./AppearancePreviewFrame";

import type { JSX } from "react";

import type { AppearancePreviewState } from "@/src/types/appearancePreview.types";

interface AppearancePreviewProps {
  state: AppearancePreviewState | null;
}

function AppearancePreview({ state }: AppearancePreviewProps): JSX.Element {
  const { t } = useTranslation("editor-appearance");
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { data: project } = useQuery({
    ...ProjectAPI.generateQuery({
      fn: ProjectAPI.getProject,
      params: [projectSlug],
    }),
    enabled: !!projectSlug,
  });
  // En dev l'API est celle de staging : la variable (`{slug}` remplacé par le projet) pointe vers le storefront local
  const baseUrl =
    process.env.APPEARANCE_PREVIEW_BASE_URL?.replace(
      "{slug}",
      projectSlug ?? "",
    ) ?? project?.base_url;

  if (!baseUrl || !isValidHttpUrl(baseUrl)) {
    return (
      <div className="text-muted-foreground flex size-full flex-col items-center justify-center gap-2 px-6 text-center text-sm">
        <MonitorPlay className="size-6" />
        <p>{t("previewPlaceholder")}</p>
      </div>
    );
  }

  return (
    <AppearancePreviewFrame key={baseUrl} baseUrl={baseUrl} state={state} />
  );
}

export default AppearancePreview;
